"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APButton = _interopRequireDefault(require("../../../common/APButton"));
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
require("./ApiKeysSidePaneButtonComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('api-keys-side-pane-button');
var ApiKeysSidePaneButtonComponent = function ApiKeysSidePaneButtonComponent(_ref) {
  var openApiKeysSidePane = _ref.openApiKeysSidePane;
  var _useTranslation = (0, _reactI18next.useTranslation)("user"),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "submit",
    customClass: baseClasses(),
    onClick: openApiKeysSidePane
  }, t("API Key"));
};
ApiKeysSidePaneButtonComponent.propTypes = {
  openApiKeysSidePane: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = ApiKeysSidePaneButtonComponent;